import { KatapultElement, html } from '../../mixins/katapult-element.js';
import '@polymer/iron-icons/hardware-icons.js';
import '../material-icon/material-icon.js';
import { Repeat } from '../../modules/Repeat.js';

class PaperHeader extends KatapultElement {
  static get template() {
    return html`
      <style>
        :host {
          display: flex;
          flex-direction: row;
          align-items: center;
          background: var(--paper-grey-200);
          color: var(--primary-text-color-faded);
          /* padding: 8px 16px; */
          font-size: 11pt;
          /* text-transform: uppercase; */
          transition: box-shadow 0.3s;
          /* min-height: 48px; */
          box-sizing: border-box;
          /* 12/3 Commented due to overlapping with katapult-drop-down */
          /*z-index: 1;*/
          user-select: none;
          -webkit-user-select: none; /* Safari */
          @apply --paper-header;
        }
        :host([tall]) {
          min-height: 56px;
        }
        ::slotted(iron-icon) {
          margin-right: 8px;
        }
      </style>
      <paper-row expand$="[[expand]]">
        <slot></slot>
      </paper-row>
    `;
  }

  static get properties() {
    return {
      expand: {
        type: Boolean
      },
      tall: {
        type: Boolean,
        reflectToAttribute: true
      }
    };
  }
}
window.customElements.define('paper-header', PaperHeader);

class PaperHeaderContent extends KatapultElement {
  static get template() {
    return html`
      <style>
        :host {
          display: block;
        }
        :host([opened]) > paper-header {
          @apply --shadow-elevation-2dp;
        }
        :host(:not([opened])) > paper-header {
          @apply --paper-header-closed;
        }
        :host([opened]:not([no-icon-rotate])) paper-header > paper-cell[icon] {
          transform: rotate(180deg);
        }
        :host([white]) paper-header {
          background: white;
        }
        paper-header {
          position: relative;
          background: var(--paper-grey-200);
          @apply --paper-header;
        }
        paper-header:hover {
          @apply --paper-header-hover;
        }
        paper-header > div {
          display: flex;
          align-items: center;
        }
        paper-cell[icon] {
          transition: transform 0.3s;
        }
      </style>
      <paper-header tall="[[tall]]" expand="[[expand]]" on-click="headerClicked">
        <slot name="header"></slot>
        <template is="dom-if" if="[[!removeIcon]]">
          <paper-cell pointer$="[[!or(hideIcon, noExpand)]]" icon on-click="iconClicked">
            <template is="dom-if" if="[[!or(hideIcon, noExpand)]]">
              <material-icon icon="[[icon]]"></material-icon>
            </template>
          </paper-cell>
        </template>
        <slot name="header-end"></slot>
      </paper-header>
      <iron-collapse no-animation="[[noAnimation]]" opened="[[_opened]]">
        <slot name="content"></slot>
      </iron-collapse>
    `;
  }

  static get properties() {
    return {
      expand: {
        type: Boolean
      },
      tall: {
        type: Boolean,
        reflectToAttribute: true
      },
      opened: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true,
        observer: 'openedChanged'
      },
      _opened: {
        type: Boolean,
        readOnly: true,
        value: false,
        observer: '_openedChanged'
      },
      icon: {
        type: String,
        value: 'keyboard_arrow_down'
      },
      render: {
        type: Boolean,
        readOnly: true,
        value: false,
        notify: true
      },
      noClickRow: {
        type: Boolean,
        value: false
      },
      removeIcon: {
        type: Boolean,
        value: false
      },
      hideIcon: {
        type: Boolean,
        value: false
      },
      noIconRotate: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      noExpand: {
        type: Boolean,
        value: false,
        observer: 'noExpandChanged'
      }
    };
  }
  ready() {
    super.ready();
  }
  close() {
    this.opened = false;
  }
  headerClicked(e) {
    this.dispatchEvent(new CustomEvent('header-click'));
    if (!this.noClickRow) this.toggle();
  }
  iconClicked(e) {
    e.stopPropagation();
    if (!this.hideIcon) this.toggle();
  }
  noExpandChanged() {
    if (this.noExpand) this.close();
  }
  open() {
    if (!this.noExpand) this.opened = true;
  }
  openedChanged() {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.opened) {
      this._setRender(true);
      this.timeout = setTimeout(() => {
        this._set_opened(true);
      });
    } else {
      this._set_opened(false);
      this.timeout = setTimeout(() => {
        this._setRender(false);
      }, 3000);
    }
  }
  _openedChanged() {
    this.repeatKey = Repeat(
      this.repeatKey,
      () => {
        this.dispatchEvent(new CustomEvent('resize'));
      },
      300
    );
  }
  toggle() {
    if (!this.noExpand) this.opened = !this.opened;
  }
}
window.customElements.define('paper-header-content', PaperHeaderContent);
